export default __webpack_public_path__ + "static/media/conrad2.89218db2.jpg";